// import ChatService from './chat.service';
//http://192.168.1.32
//http://localhost
//https://accounting-manager.com
import { PermissionsContext } from '../Contexts/Permissions';
import axios from 'axios';
import config from '../config';
import selectedEnvironment from '../env';
import Constants from '../assests/Constants/constants';
import Cookies from 'js-cookie';
import PolicyService from './policy.service';
import {
  restorePreservedLocalStorage,
  snapshotPreservedLocalStorage,
} from '../Utils/persistedLocalStorage';
import { clearAllAppStateOnLogout } from '../Utils/cacheManager';
const API_URL = `${config[selectedEnvironment].API_URL}/Auth`;



// Log in a user
const login = async (accountantId, password, userType) => {
  return axios.post(API_URL + '/login', {
    username: accountantId,
    password,
    userType: userType,
    IsFromApplication: false
  }).then(async (response) => {
    const userType = JSON.stringify(response.data.userType);
    const user = JSON.stringify(response.data.user);
    const token = JSON.stringify(response.data.token);
    localStorage.setItem('user', user);
    localStorage.setItem('token', token);
    localStorage.setItem('userType', userType);

    return response.data;
  })
    .catch(error => {
      const data = error.response?.data;
      const errorMessage =
        (typeof data === 'string' && data) ||
        data?.message ||
        'Login failed';
      throw { message: errorMessage };
    });
};

// Log out the current user — clears Redux, persist, storage, and cookies
const logout = async () => {
  try {
    // Wipe in-memory Redux + redux-persist before clearing localStorage,
    // so a re-login never sees the previous accountant's cached client list.
    await clearAllAppStateOnLogout();

    const preservedLocalStorage = snapshotPreservedLocalStorage();
    localStorage.clear();
    sessionStorage.clear();
    restorePreservedLocalStorage(preservedLocalStorage);

    // Call the API to remove the HttpOnly cookie on the server
    await PolicyService.logout();

    // Remove client-side (non-HttpOnly) cookies just in case
    Cookies.remove('privacy_policy_accepted', { path: '/' });

    document.cookie.split(';').forEach(cookie => {
      const name = cookie.split('=')[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    });

  } catch (error) {
    console.error('Error during logout:', error);
  }
};

const getResponseErrorMessage = async (response) => {
  try {
    const text = await response.text();
    if (!text) return null;
    try {
      const parsed = JSON.parse(text);
      if (typeof parsed === 'string') return parsed;
      return parsed?.message || parsed?.title || text;
    } catch {
      return text;
    }
  } catch {
    return null;
  }
};

const sendOtp = async (Username, UserType) => {
  const response = await fetch(`${API_URL}/forgot-password`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ Username, UserType })
  });

  if (!response.ok) {
    const message = await getResponseErrorMessage(response);
    throw new Error(message || `HTTP error! status: ${response.status}`);
  }

  return response;
};

const verifyOtp = async (Username, otp, UserType) => {

  const response = await fetch(`${API_URL}/verify-otp`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ Username, UserType, otp })
  });

  if (!response.ok) {
    const message = await getResponseErrorMessage(response);
    throw new Error(message || 'Invalid or expired OTP');
  }

  return response;
};

const resetPassword = async (UserId, NewPassword, UserType, OldPassword = null) => {
  const payload = { UserId, UserType, NewPassword };
  
  // Include OldPassword if provided (don't send null/undefined)
  if (OldPassword) {
    payload.OldPassword = OldPassword;
  }

  const response = await fetch(`${API_URL}/ResetPassword`, {
    method: 'PUT',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  return response;
};

const CheckTokenValidation = async (token) => {
  const response = await fetch(`${API_URL}/CheckTokenValidation`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ Token: token })
  });

  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    throw new Error('Failed to validate token');
  }
};


const getCurrentUser = async () => {
  try {
    const userData = localStorage.getItem('user');
    return userData ? JSON.parse(userData) : null;
  } catch (e) {
    console.error('Failed to retrieve user data', e);
    return null;
  }
};
/**
 * Returns the identifier of the CURRENTLY-LOGGED-IN user (never the
 * currently-viewed client when an accountant is browsing a case).
 *
 *   • Client       → user.caseId        (the unique key of Client table;
 *                                          Client.ClientId is NOT unique and
 *                                          must never be used as a user id.)
 *   • Accountant   → accountant.accountantId
 *   • SubAccountant→ accountant.subAccountantId
 *
 * Credit-terminal endpoints (and all owner-scoped APIs) rely on this id.
 */
const getCurrentUserTypeId = async () => {
  const userType = await getCurrentUserType();
  if (!userType) return null;

  switch (userType.toString()) {
    case '1': {
      const user = await getCurrentUser();
      return user?.caseId ?? null;
    }
    case '2': {
      const accountant = localStorage.getItem('user');
      const parsedAccountant = accountant ? JSON.parse(accountant) : null;
      return parsedAccountant?.accountantId ?? null;
    }
    case '8': {
      const accountant = localStorage.getItem('user');
      const parsedAccountant = accountant ? JSON.parse(accountant) : null;
      return parsedAccountant?.subAccountantId ?? null;
    }
    default:
      throw new Error("Invalid user type.");
  }
};

const getCurrentUserTypeAccountantId = async () => {
  const userType = await getCurrentUserType(); // Get the parsed user type

  if (!userType) {
    // throw new Error("User type is not set in localStorage.");
    return null
  }

  switch (userType.toString()) {
    case '1': {
      const user = await getCurrentUser();
      return user?.accountantId;
    }
    case '2': {
      const accountant = localStorage.getItem('user');
      const parsedAccountant = accountant ? JSON.parse(accountant) : null;
      return parsedAccountant?.accountantId;
    }
    case '8': {
      const accountant = localStorage.getItem('user');
      const parsedAccountant = accountant ? JSON.parse(accountant) : null;
      return parsedAccountant?.accountantId;
    }
    default:
      throw new Error("Invalid user type.");
  }
};

const getCurrentUserByType = async () => {
  const userType = await getCurrentUserType(); // Get the parsed user type

  if (!userType) {
    // throw new Error("User type is not set in localStorage.");
    return null
  }

  switch (userType.toString()) {
    case '1': {
      const user = await getCurrentUser();
      return user; // Return the full user object for type '1'
    }
    case '2': {
      const accountant = localStorage.getItem('user');
      return accountant ? JSON.parse(accountant) : null; // Return the accountant object for type '2'
    }
    case '8': {
      const accountant = localStorage.getItem('user');
      const parsedAccountant = accountant ? JSON.parse(accountant) : null;
      return parsedAccountant; // Return the accountant object for type '8'
    }
    default:
      throw new Error("Invalid user type.");
  }
};


const getCurrentUserPermissonType = async () => {
  const userType = await getCurrentUserType(); // Get the parsed user type

  if (!userType) {
    // throw new Error("User type is not set in localStorage.");
    return null
  }

  switch (userType.toString()) {
    case '1': {
      return Constants.PermissionUserType.Client; // Return the full user object for type '1'
    }
    case '2': {
      return Constants.PermissionUserType.Accountant; // Return the accountant object for type '2'
    }
    case '8': {
      return Constants.PermissionUserType.SubAccountant; // Return the accountant object for type '8'
    }
    default:
      throw new Error("Invalid user type.");
  }
};
const getCurrentUserType = async () => {
  const userType = localStorage.getItem('userType');
  return userType != null ? JSON.parse(userType) : null;
};

const getCurrentUserTypeName = async () => {
  const userType = await getCurrentUserType(); // Get the parsed user type

  if (!userType) {
    // throw new Error("User type is not set in localStorage.");
    return null
  }

  switch (userType.toString()) {
    case '1': {
      const user = await getCurrentUser();
      return user?.name;
    }
    case '2': {
      const accountant = localStorage.getItem('user');
      const parsedAccountant = accountant ? JSON.parse(accountant) : null;
      return parsedAccountant?.name;
    }
    case '8': {
      const accountant = localStorage.getItem('user');
      const parsedAccountant = accountant ? JSON.parse(accountant) : null;
      return parsedAccountant?.name;
    }
    default:
      throw new Error("Invalid user type.");
  }
};

const getCurrentToken = async () => {
  const token = localStorage.getItem('token');
  return token != null ? JSON.parse(token) : null;
};

const EnableDisable = async (userId, userType, isActive, token) => {
  try {
    const response = await axios.put(
      `${API_URL}/EnableDisable`,
      { userId, userType, isActive },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('EnableDisable action failed');
    }
  } catch (error) {
    console.error('Error in EnableDisable:', error);
    throw error;
  }
};

const AuthService = {
  login,
  logout,
  sendOtp,
  verifyOtp,
  resetPassword,
  CheckTokenValidation,
  getCurrentUserTypeName,
  getCurrentUserByType,
  getCurrentUserTypeAccountantId,
  getCurrentUserTypeId,
  getCurrentToken,
  getCurrentUserType,
  getCurrentUserPermissonType,
  EnableDisable
};

export default AuthService;
